export default __webpack_public_path__ + "static/media/Happy Lofi.e5bbd62a.mp3";